import React from 'react';
import styles from "../../../BookingForm.module.scss";

export default function BriefBody({ brief, handleOpen, disabled }) {
  return (
    <div>
      <div>
        { brief }
      </div>
      {
        !disabled && (
          <span
            onClick={() => handleOpen()}
            className={styles.read_button}
          >
            Edit
          </span>
        )
      }
    </div>
  );
}